import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { housingSelectionAssistantPageQueryOptions } from "~/app/api/pageData/housingSelectionAssistantPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createHousingSelectionAssistant } from "~/pages/HousingSelectionAssistantPage/HousingSelectionAssistantPage";

function HousingSelectionAssistantRoute() {
  const result = useLoaderData({
    from: "/housingselectionassistant",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {createHousingSelectionAssistant()}
    </StorefrontShellFrame>
  );
}

export async function loadHousingSelectionAssistantPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(housingSelectionAssistantPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const housingSelectionAssistantRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/housingselectionassistant",
  loader: async ({ context }) => loadHousingSelectionAssistantPageData(context),
  component: HousingSelectionAssistantRoute,
});
